export default __webpack_public_path__ + "static/media/create_point.4b9dab77.png";